import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomerService } from 'src/app/core/services/customer.service';
import { AdministrativeInfo, AdministrativeInfoContainer } from 'src/app/model/AdministrativeInfo';
import { ProductCode } from 'src/app/model/industry';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { LoginService } from 'src/app/core/services/login.service';

@Component({
    selector: 'ms-technical-support',
    templateUrl: './technical-support.component.html',
    styleUrls: ['./technical-support.component.scss'],
})
export class TechnicalSupportComponent implements OnInit {
    isLoading: boolean = false;
    public administrativeInfo: Subscription;
    canSeeIncidentsCatalog: boolean = false;
    canSeeTicketingHDA: boolean = false;
    canSeePassKey: boolean = false;
    authorizationStored;
    authorizationProperties: AuthorizationProperties;
    constructor(
        public customerService: CustomerService,
        public storeRolesService: StoreRolesService,
        private loginService: LoginService,
        private storeRoleService: StoreRolesService
    ) {}

    ngOnInit(): void {
      this.administrativeInfo = this.customerService.companyInfo$.subscribe((companyInfo) => {
        this.checkIfCanSeePassKey(companyInfo)
      });
    }
    public checkIfCanSeePassKey(companyInfo: AdministrativeInfo) {
      this.authorizationStored = this.loginService.getauthinfo();
      this.authorizationProperties = JSON.parse(this.authorizationStored);
      this.canSeeTicketingHDA = this.storeRoleService?.isReseller || this.storeRolesService?.isZucchettiAccount || this.storeRolesService?.IsInternal;
      this.canSeeIncidentsCatalog = this.storeRoleService?.isReseller || this.storeRolesService?.isZucchettiAccount || this.storeRolesService?.IsInternal;
      if (this.storeRolesService?.isZucchettiAccount || this.storeRolesService?.IsInternal)
        this.canSeePassKey = true;
      else if (this.storeRolesService?.isMago4_Partner) {
        if (!companyInfo)
          this.canSeePassKey = false;
        this.canSeePassKey = ( AdministrativeInfoContainer.isPlatinumPartner(this.customerService.ListOfMandati, ProductCode.MAGO4) || AdministrativeInfoContainer.isGoldPartner(this.customerService.ListOfMandati, ProductCode.MAGO4) );
      }
    }
}
